import * as actionTypes from './actionTypes';

export const INITIAL_STATE = {
	editions: [],
	pagination: {},
	editionsLoading: true,
	editionsError: null,
	saving: false,
	savingError: null,
	viewedEdition: null,
	editedEdition: null,
	editedLicenseId: null
};

/*
 * `editionsLoading` starts true so the table shows its preloader before the first response lands,
 * rather than flashing "no editions" at someone whose list is still on the wire.
 */
const editionsReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case actionTypes.START_FETCHING_EDITIONS:
			return { ...state, editionsLoading: true, editionsError: null };
		case actionTypes.GET_EDITIONS_SUCCESS:
			return {
				...state,
				editions: action.payload.editions,
				pagination: action.payload.pagination,
				editionsLoading: false,
				editionsError: null
			};
		case actionTypes.GET_EDITIONS_ERROR:
			return { ...state, editionsLoading: false, editionsError: action.payload };

		case actionTypes.START_SAVING_EDITION:
			return { ...state, saving: true, savingError: null };
		case actionTypes.SAVE_EDITION_SUCCESS:
			return { ...state, saving: false, savingError: null };
		case actionTypes.SAVE_EDITION_ERROR:
			return { ...state, saving: false, savingError: action.payload };
		/*
		 * Deliberately not an error: the write was abandoned, not refused, so there is no reason to
		 * show anybody who comes back a message about it. The open modal comes down with the flag -
		 * clearing `saving` alone would leave a returning user staring at a dialog for a write that
		 * is no longer running.
		 */
		case actionTypes.SAVE_EDITION_ABORTED:
			return { ...state, saving: false, savingError: null, editedEdition: null };

		/*
		 * View and edit are mutually exclusive: Edit from inside the view dialog swaps one for the
		 * other rather than stacking two dialogs on the same edition.
		 */
		case actionTypes.SHOW_EDITION_VIEW_MODAL:
			return { ...state, viewedEdition: action.payload, editedEdition: null };
		case actionTypes.HIDE_EDITION_VIEW_MODAL:
			return { ...state, viewedEdition: null };
		case actionTypes.SHOW_EDITION_EDIT_MODAL:
			return { ...state, editedEdition: action.payload, viewedEdition: null, savingError: null };
		case actionTypes.HIDE_EDITION_EDIT_MODAL:
			return { ...state, editedEdition: null };

		/*
		 * The edition dialog that was open is left in place: the page hides it while the license
		 * form is up and shows it again after, so the tiers picked so far are not thrown away.
		 */
		case actionTypes.SHOW_LICENSE_EDIT_MODAL:
			return { ...state, editedLicenseId: action.payload };
		case actionTypes.HIDE_LICENSE_EDIT_MODAL:
			return { ...state, editedLicenseId: null };

		default:
			return state;
	}
};

export default editionsReducer;
